import { useState, useEffect } from "react";
import { B } from "../../design/tokens";

export default function Navbar({ active, nav }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [prog, setProg] = useState(0);

  useEffect(() => {
    const h = () => {
      setScrolled(window.scrollY > 64);
      const total = document.body.scrollHeight - window.innerHeight;
      if (total > 0) setProg((window.scrollY / total) * 100);
    };
    window.addEventListener("scroll", h, { passive: true });
    return () => window.removeEventListener("scroll", h);
  }, []);

  const links = [
    { id: "home",      label: "Home"     },
    { id: "about",     label: "About"    },
    { id: "services",  label: "Services" },
    { id: "portfolio", label: "Work"     },
    { id: "blog",      label: "Insights" },
    { id: "contact",   label: "Contact"  },
  ];

  return (
    <nav style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000,
      background: scrolled ? "rgba(6,14,30,0.97)" : "transparent",
      backdropFilter: scrolled ? "blur(18px)" : "none",
      borderBottom: scrolled ? `1px solid ${B.hairline}` : "none",
      transition: "all 0.4s ease",
    }}>
      <div style={{ position: "absolute", bottom: 0, left: 0, height: "2px", width: `${prog}%`, background: `linear-gradient(90deg, ${B.azure}, ${B.mist})`, transition: "width 0.1s linear" }} />
      <div style={{ maxWidth: 1280, margin: "0 auto", padding: scrolled ? "12px 32px" : "20px 32px", display: "flex", alignItems: "center", justifyContent: "space-between", transition: "padding 0.4s ease" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 11, cursor: "pointer" }} onClick={() => nav("home")}>
          <div style={{ width: 38, height: 38, background: `linear-gradient(135deg, ${B.azure}, ${B.royal})`, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Cormorant Garamond', serif", fontWeight: 800, fontSize: 20, color: B.white, boxShadow: `0 4px 18px ${B.azure}44` }}>N</div>
          <div>
            <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 700, fontSize: 19, color: B.white, letterSpacing: 2, lineHeight: 1 }}>NESW</div>
            <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 8.5, color: `${B.mist}bb`, letterSpacing: 2.5, textTransform: "uppercase", marginTop: 2 }}>By Jessamyn Rubio</div>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 32 }} className="nav-desktop">
          {links.map(l => (
            <button key={l.id} onClick={() => nav(l.id)} style={{ background: "none", border: "none", cursor: "pointer", fontFamily: "'Space Grotesk', sans-serif", fontSize: 13.5, fontWeight: 500, color: active === l.id ? B.white : `${B.white}80`, letterSpacing: 0.4, transition: "color 0.25s", padding: "2px 0", position: "relative" }}
              onMouseEnter={e => e.currentTarget.style.color = B.white}
              onMouseLeave={e => e.currentTarget.style.color = active === l.id ? B.white : `${B.white}80`}
            >
              {l.label}
              {active === l.id && <span style={{ position: "absolute", bottom: -4, left: 0, right: 0, height: 1.5, background: `linear-gradient(90deg, ${B.azure}, ${B.mist})`, borderRadius: 2 }} />}
            </button>
          ))}
          <button onClick={() => nav("contact")} style={{ background: `linear-gradient(135deg, ${B.azure} 0%, ${B.royal} 100%)`, color: B.white, border: "none", padding: "10px 24px", fontFamily: "'Space Grotesk', sans-serif", fontSize: 13, fontWeight: 600, letterSpacing: 0.5, cursor: "pointer", transition: "all 0.3s", boxShadow: `0 2px 18px ${B.azure}44` }}
            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-1px)"; e.currentTarget.style.boxShadow = `0 6px 28px ${B.azure}55`; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = `0 2px 18px ${B.azure}44`; }}
          >Get in Touch</button>
        </div>
        <button onClick={() => setOpen(!open)} className="nav-mobile-btn" style={{ display: "none", background: "none", border: "none", cursor: "pointer", padding: 6, flexDirection: "column", gap: 5 }}>
          {[0,1,2].map(i => (
            <span key={i} style={{ display: "block", width: 22, height: 2, background: B.white, borderRadius: 1, transition: "all 0.3s", transform: open ? (i === 0 ? "rotate(45deg) translate(5px,5px)" : i === 2 ? "rotate(-45deg) translate(5px,-5px)" : "none") : "none", opacity: open && i === 1 ? 0 : 1 }} />
          ))}
        </button>
      </div>
      {open && (
        <div style={{ background: B.navy, borderTop: `1px solid ${B.hairline}`, padding: "18px 32px 28px" }}>
          {links.map(l => (
            <button key={l.id} onClick={() => { nav(l.id); setOpen(false); }} style={{ display: "block", width: "100%", textAlign: "left", background: "none", border: "none", padding: "13px 0", cursor: "pointer", fontFamily: "'Space Grotesk', sans-serif", fontSize: 16, fontWeight: 500, color: active === l.id ? B.mist : `${B.white}80`, borderBottom: `1px solid ${B.hairline}` }}>{l.label}</button>
          ))}
          <button onClick={() => { nav("contact"); setOpen(false); }} style={{ marginTop: 20, width: "100%", background: `linear-gradient(135deg, ${B.azure}, ${B.royal})`, color: B.white, border: "none", padding: "14px", fontFamily: "'Space Grotesk', sans-serif", fontSize: 14, fontWeight: 600, cursor: "pointer", letterSpacing: 0.5 }}>Get in Touch</button>
        </div>
      )}
    </nav>
  );
}
